import {Component} from '@angular/core';

import {
    // ActionSheetController,
    // AlertController,
    // MenuController,
    // ModalController,
    NavController,
    Platform,
    // PopoverController,
    // ToastController
} from '@ionic/angular';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import {StatusBar} from '@ionic-native/status-bar/ngx';
import {InAppBrowser} from '@ionic-native/in-app-browser/ngx';
import {Router} from '@angular/router';
import { ApiBasicService } from './services/api/api-basic.service';
import {AppConfigService} from './services/app-config.service';
import {AppLogService} from './services/app-log.service';
import {Storage} from '@ionic/storage';
import {addIcons} from 'ionicons';
import {arrowBack, chevronForward, close} from 'ionicons/icons';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent {

    pagesHighlighted: {
        title: string,
        url: string,
        icon: string
    }[];
    pages: {
        title: string,
        url: string,
        icon: string,
        external?: boolean
    }[];
    revision: any;
    scannerSerial: any;
    window = window;
    loaded = false;
    message = '';
    private startupPromise?: Promise<void>;


    private STORAGE_ID = 'STATE';
    constructor(
        private platform: Platform,
        private splashScreen: SplashScreen,
        private statusBar: StatusBar,
        private iab: InAppBrowser,
        private router: Router,
        private navController: NavController,
        private apiBasicService: ApiBasicService,
        private storage: Storage,
        private appConfigService: AppConfigService,
        private appLogService: AppLogService,
    ) {
        // Bundle the icons used by the app instead of loading their SVG files at runtime.
        // Runtime asset URLs are not reliable in packaged Electron environments.
        addIcons({arrowBack, chevronForward, close});
        // do not allow sleep on smartphone
        void this.initialize();
    }

    setMessage(message: string) {
        this.message = message ?? '';
    }

    private async initialize() {
        await this.initializeApp();
        await this.subscribeToServiceInitialisations();
    }

    private async initializeApp() {
        this.setMessage('INITIALIZING ENGINE...');
        await this.platform.ready();
    }

    private checkServiceInitialisation(): Promise<void> {
        this.startupPromise ??= this.startApplication();
        return this.startupPromise;
    }

    private async startApplication(): Promise<void> {
        this.setMessage('INITIALIZING SERVICES...');
        // Custom design URLs are used by the Electron wrapper on fixed kiosks. This early return
        // intentionally skips Android's first-time reset below; revisit it if Cordova/Android
        // ever starts directly on a /design/<name> URL.
        if (window.location.pathname.startsWith('/design/')) {
            this.setMessage('RENDERING CUSTOM DESIGN...');
            this.hideNavigatorSplashScreen();
            this.loaded = true;
            localStorage.removeItem('serial');
            this.router.initialNavigation();
            return;
        }

        // TODO: Make localStorage persistent
        if (this.platform.is('cordova') && this.platform.is('android')) {
            const isInit = localStorage.getItem('isInit');
            if (!(isInit === 'true')) {
                this.setMessage('PERFORMING FIRST-TIME SETUP...');
                await localStorage.clear();
                await this.storage.clear();
                caches.keys().then(keys => {
                    keys.forEach(key => caches.delete(key));
                });
                document.cookie = document.cookie.split(';').reduce((newCookie1, keyVal) => {
                    const pair = keyVal.trim().split('=');
                    if (pair[0]) {
                        if (pair[0] !== 'path' && pair[0] !== 'expires') {
                            newCookie1 += pair[0] + '=;';
                        }
                    }
                    return newCookie1;
                }, 'expires=Thu, 01 Jan 1970 00:00:00 UTC; path:/;');
            }
            const date = new Date();
            date.setDate(date.getDate() + 365);
            document.cookie = `isInit=true; expires=${date.toUTCString()}`;
            localStorage.setItem('isInit', 'true');
        }
        await new Promise(resolve => setTimeout(resolve, 100));

        this.setMessage('RENDERING DESIGN...');
        try {
            await this.appConfigService.load(undefined, undefined, true);
        } catch (error) {
            console.error('Initial configuration load failed unexpectedly.', error);
        } finally {
            this.hideNavigatorSplashScreen();
            this.loaded = true;
            await this.navController.navigateRoot('/download', {
                animated: false,
                replaceUrl: true,
            });
        }
        if (this.platform.is('cordova')) {
            // Maybe a guard will trigger, so wait half a second until hiding the splash screen
            window.setTimeout(() => {
                this.splashScreen.hide();
            }, 500);
        }
    }

    private hideNavigatorSplashScreen(): void {
        try {
            // @ts-ignore
            window.navigator.splashscreen.hide();
        } catch (e) {
            // The web and Electron runtimes do not expose Cordova's splash screen.
        }
    }

    private subscribeToServiceInitialisations(): Promise<void> {
        return this.checkServiceInitialisation();
    }

}
